import { BrowserRouter,Redirect } from "react-router-dom";

import React, {useEffect,useState} from "react";
const PrivateRoutes = () => {
    let auth = {'token':false}
    return(
        localStorage.getItem('isAuthUser') === 'true' ? <BrowserRouter/> : <Redirect to={{ pathname: "/login"}} />
    )
}

export default PrivateRoutes